export default __webpack_public_path__ + "static/media/leafRight.04da50ea.png";